module.exports = __webpack_public_path__ + "static/media/Agentur_5W-50_Automobilmarketing.4e06dd6d.mp4";